import React from "react";

export default ({ children }) => (
    <header css={{
        height: 64,
        borderBottom: "1px solid rgba(200, 200, 200, .2)",
    }}>
        <div css={{
            padding: "0 15px",
            height: "100%",
            maxWidth: 1000,
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        }}>
            { children }
        </div>
    </header>
);
